/* eslint-disable no-console */
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

export const getPlaceholderData = async (params) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PLACEHOLDER.GET_PLACEHOLDER}`, {
      ...params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const postPlaceholderData = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PLACEHOLDER.SAVE_PLACEHOLDER}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deletePlaceholder = async (id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.PLACEHOLDER.DELETE_PLACEHOLDER}`, { params: id });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateQty = async (params) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PLACEHOLDER.UPDATE_QTY}`, {
      ...params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getPlaceholderProduct = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PLACEHOLDER.GET_PRODUCT}`, {
      params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const postPlaceholderProductData = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PLACEHOLDER.SAVE_PRODUCT_PLACEHOLDER}`, { devorderData: data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getSearchedProductListService = async (searchValue) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PLACEHOLDER.FETCH_SEARCHED_PRODUCT}`, {
      params: { searchValue },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const saveDraftData = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PLACEHOLDER.SAVE_DRAFT}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const publishPlacheholderManagement = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PLACEHOLDER.PUBLISH_DRAFT}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const replacePlaceholderSevice = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PLACEHOLDER.REPLACE_PLACEHOLDER}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addPlaceholderCard = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.PLACEHOLDER.ADD_PLACEHOLDER_CARD}`, { ...data });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getIndividualDetails = async (id) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PLACEHOLDER.GET_INDIVIDUAL_DETAILS}`, {
      params: { id },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getPlaceholderCardData = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.PLACEHOLDER.GET_PLACEHOLDER_CARD}`, {
      params,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deletePlaceholderCardData = async (id) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.PLACEHOLDER.DELETE_PLACEHOLDER_CARD}`, {
      params: { id },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const archivePlaceholderCardData = async (id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.PLACEHOLDER.ARCHIVE_PLACEHOLDER_CARD}`, {
      ...id,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
